<template>
<div>
  <span class="grant" v-if="status === 'grant'">Concluído</span>
  <span class="deny" v-if="status === 'deny'">Cancelado</span>
  <span class="processing" v-if="status === 'processing'">Em análise</span>
  <span class="pendency" v-if="status === 'pendency'">Sob correção</span>
</div>
</template>

<script>
export default {
  props: ['status']
}
</script>

<style scoped>
.grant {
  color: green
}
.deny {
  color: red
}
.processing {
  color: blue
}
.pendency {
  color: #bf9600
}
</style>



// WEBPACK FOOTER //
// RequestStatus.vue?f92ca960